(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["dynamic-text"] && !window.DesignMode) return;
  try {
    

 var TxtType = function(el, toRotate, period) {
        this.toRotate = toRotate;
        this.el = el;
        this.loopNum = 0;
        this.period = parseInt(period, 10) || 2000;
        this.txt = '';
        this.tick();
        this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
        var i = this.loopNum % this.toRotate.length;
        var fullTxt = this.toRotate[i];

        if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
        } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
        }

        this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

        var that = this;
        var delta = 200 - Math.random() * 100;

        if (this.isDeleting) { delta /= 2; }

        if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
        } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
        }

        setTimeout(function() {
        that.tick();
        }, delta);
    };

    window.onload = function() {
        var elements = document.getElementsByClassName('typewrite');
        for (var i=0; i<elements.length; i++) {
            var toRotate = elements[i].getAttribute('data-type');
            var period = elements[i].getAttribute('data-period');
            if (toRotate) {
              new TxtType(elements[i], JSON.parse(toRotate), period);
            }
        }
        // INJECT CSS
        var css = document.createElement("style");
        css.type = "text/css";
        css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
        document.body.appendChild(css);
    };


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["richtext"] && !window.DesignMode) return;
  try {
    
// Importez la bibliothèque GSAP en ajoutant une balise <script> dans votre fichier HTML

// Assurez-vous que le script s'exécute après le chargement du DOM
document.addEventListener("DOMContentLoaded", function() {
  // Initialisez GSAP et enregistrez le plugin ScrollTrigger
  gsap.registerPlugin(ScrollTrigger);

  // Sélectionnez tous les éléments avec la classe "impact"
  var impactElements = document.querySelectorAll(".impact");

  impactElements.forEach(function(element) {
    var count = element;
    var zero = { val: 0 };
    var num = count.getAttribute("data-number");
    var split = (num + "").split(".");
    var decimals = split.length > 1 ? split[1].length : 0;

    gsap.to(zero, {
      val: num,
      duration: 4,
      scrollTrigger: element,
      onUpdate: function() {
        count.textContent = zero.val.toFixed(decimals);
      }
    });
  });
});


  } catch(e) { console.error(e); }
})();

})();
